import { OEMSProvider } from "@app-context/oems/OEMSProvider";
import { ReportsProvider } from "@app-context/reports/ReportsProvider";
import { CenterContent, ContentMessage } from "@enfusion-ui/web-components";
import { styled } from "@enfusion-ui/web-core";

import {
  RequestTypes,
  useInspectorContext,
} from "../../context/inspector/context";
import { HTTPContent } from "./HTTPContent";
import { OEMSContent } from "./OEMSContent";
import { ReportContent } from "./ReportContent";
import { RestContent } from "./RestContent";

export const BodyContent = styled.div`
  word-break: break-word;
  width: 100%;
  display: block;
  white-space: pre-wrap;
`;

export const Line = styled.hr`
  border-color: var(--primary);
  width: 100%;
  margin-top: 0px;
  margin-bottom: var(--spacing);
`;

export const ResponseTab = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  height: 100%;
  width: 100%;
`;

export const ResponseContainer = styled.div`
  padding: var(--spacing);
  flex: 1;
  overflow: auto;
`;

export type ContentProp = {
  selectedParamTab: string;
  paramsOpen: boolean;
  setParamsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const InspectorContent = (props: any) => {
  const { requestType } = useInspectorContext();

  switch (requestType) {
    case RequestTypes.HTTP:
      return <HTTPContent {...props} />;
    case RequestTypes.REPORT:
      return (
        <ReportsProvider>
          <ReportContent {...props} />
        </ReportsProvider>
      );
    case RequestTypes.ENFUSION:
      return <RestContent {...props} />;
    case RequestTypes.OEMS:
      return (
        <OEMSProvider>
          <OEMSContent {...props} />
        </OEMSProvider>
      );
    default:
      return (
        <div>
          <CenterContent>
            <ContentMessage message="No Content" />
          </CenterContent>
        </div>
      );
  }
};
